import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const securitySettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("security-settings", "Security Settings"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("security-settings-alt-keyword-1", "password length"),
        t("security-settings-alt-keyword-2", "password complexity"),
        t("security-settings-alt-keyword-3", "password reusability"),
        t("security-settings-alt-keyword-4", "password expiration"),
        t("security-settings-alt-keyword-5", "session duration"),
        t("security-settings-alt-keyword-6", "SAML SSO"),
        t("security-settings-alt-keyword-7", "single sign-on"),
        t("security-settings-alt-keyword-8", "PII"),
        t("security-settings-alt-keyword-9", "personally identifiable information"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
